export const ABOUT = {
  name: 'Careers',
  link: '/cariers',
};
